import { handleGetRequest } from "./http.service";

export interface MyndaUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  kycStatus: string;
  profilePicture?: { url: string };
}

export interface Mynda {
  _id: string;
  occupation?: string[];
  state?: string;
  lga?: string;
  accountVerified?: boolean;
  views?: number;
  bookings?: number;
  myndaType?: string;
  employmentType?: string;
  salaryExpectations?: number;
  agency?: string | null;
  user?: MyndaUser;
  createdAt: string;
}

export interface MyndasResponse {
  page: number;
  limit: number;
  total: number;
  data: Mynda[];
}

export const getAllMyndas = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  employeeType?: string;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.search) qs.set("search", params.search);
  if (params?.employeeType) qs.set("employeeType", params.employeeType);
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<MyndasResponse>(`/myndas${query}`);
};
